import { DollarOutlined, EyeOutlined } from "@ant-design/icons";
import { Row, Col, Divider, Button } from "antd";
import { formatMoney } from "shared/plugins/string-helper";
import { OrderModel } from "states/order/order.models";

export interface IOrderPaymentInfoProps {
  order: OrderModel;
  onViewOrAdd: () => void;
}

export function OrderPaymentInfo(props: IOrderPaymentInfoProps) {
  const { order, onViewOrAdd } = props;
  return (
    <div className="mb-2 p-2 bg-white">
      <div className="mb-2">
        <DollarOutlined /> <b>Thanh toán</b>
      </div>
      <Row
        gutter={[8, 8]}
        justify="space-between"
        align="middle"
        className="mb-2"
      >
        <Col>Tạm tính:</Col>
        <Col>{formatMoney(order.subTotal)}</Col>
      </Row>
      <Row
        gutter={[8, 8]}
        justify="space-between"
        align="middle"
        className="mb-2"
      >
        <Col>Tiền tip:</Col>
        <Col>{formatMoney(order.tipAmount)}</Col>
      </Row>
      <Row
        gutter={[8, 8]}
        justify="space-between"
        align="middle"
        className="mb-2"
      >
        <Col>Phí ship:</Col>
        <Col>{formatMoney(order.shippingFee)}</Col>
      </Row>
      <Row
        gutter={[8, 8]}
        justify="space-between"
        align="middle"
        className="mb-2"
      >
        <Col>Thuế:</Col>
        <Col>{formatMoney(order.taxes)}</Col>
      </Row>

      <Row
        gutter={[8, 8]}
        justify="space-between"
        align="middle"
        className="mb-2"
      >
        <Col>Giảm giá:</Col>
        <Col>{formatMoney(-order.discountAmount)}</Col>
      </Row>
      <Divider className="mt-2 mb-2" />
      <Row
        gutter={[8, 8]}
        justify="space-between"
        align="middle"
        className="mb-2"
      >
        <Col>Tổng cộng:</Col>
        <Col>
          <b>{formatMoney(order.totalAmount)}</b>
        </Col>
      </Row>
      <Row
        gutter={[8, 8]}
        justify="space-between"
        align="middle"
        className="mb-2"
      >
        <Col>
          Đã trả:{" "}
          <Button type="link" icon={<EyeOutlined />} onClick={onViewOrAdd}>
            Xem chi tiết
          </Button>
        </Col>
        <Col>{formatMoney(order.paidAmount)}</Col>
      </Row>
      {order.paidAmount > order.totalAmount && (
        <Row
          gutter={[8, 8]}
          justify="space-between"
          align="middle"
          className="mb-2"
        >
          <Col>Tiền thừa:</Col>
          <Col>{formatMoney(order.paidAmount - order.totalAmount)}</Col>
        </Row>
      )}
      {order.paidAmount < order.totalAmount && (
        <Row
          gutter={[8, 8]}
          justify="space-between"
          align="middle"
          className="mb-2"
        >
          <Col>Tiền thiếu:</Col>
          <Col>
            <b>{formatMoney(-order.paidAmount + order.totalAmount)}</b>
          </Col>
        </Row>
      )}
    </div>
  );
}
